import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { navigate } from 'gatsby';
import Button from '~/components/atoms/Button'
import HelpFeatures from '~/components/molecules/HelpFeatures'
import { rentalCtaLabels } from '~/data/translations/rentalCtaLabels';
import './custom-reviews-banner.css';
import { trustpilotLinkProps } from '~/data/trustpilot';

export default function RentalCta({ isHero, sideBySide = false, showReviewsBanner = true, editablePostcode = false, className = '', subheadingClassName, subheading, heading, headingBoldFrom = 'City Relay', showHelpFeatures = false, language = 'en' }) {
  const [value, setValue] = useState('');

  const labels = rentalCtaLabels[language];

  const redirects = {
    "en": "/pricing/",
    "fr": "/fr/estimation-de-location-a-paris/",
    "es": "/es/estimacion-de-alquiler-en-barcelona/",
  }

  const boldFromIndex = heading?.lastIndexOf(headingBoldFrom) ?? -1;

  const headingBlock = (
    <>
      <h6 className={`text-h6 mb-4 ${subheadingClassName}`}>{subheading}</h6>
      <h4 className="text-h2 mb-6">
        {boldFromIndex === -1 ? heading : (
          <>
            {heading.slice(0, boldFromIndex)}
            <strong>{heading.slice(boldFromIndex)}</strong>
          </>
        )}
      </h4>
    </>
  );

  const formBlock = isHero ? (
    <>
      <div className="hero-card">
        <form
          className="flex flex-col sm:flex-row input-postcode"
          onSubmit={e => {
            e.preventDefault();
            navigate(`${redirects[language]}`);
          }}
        >
          {/* Two-line postcode trigger (Figma spec) */}
          {editablePostcode ? (
            <div className="postcode-field-hero">
              <div className="postcode-label-row">
                <span className="postcode-label-text">{labels.postcode}</span>
                <svg className="postcode-chevron" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
                  <path d="M12.0005 15.7121L5.9905 9.70211L7.4035 8.28711L12.0005 12.8871L16.5965 8.28711L18.0105 9.70111L12.0005 15.7121Z" fill="#12203A"/>
                </svg>
              </div>
              <input
                type="text"
                className="postcode-placeholder postcode-placeholder-input"
                placeholder="Enter postcode"
                value={value}
                onChange={e => setValue(e.target.value)}
              />
            </div>
          ) : (
            <div
              className="postcode-field-hero"
              role="button"
              tabIndex={0}
              onClick={() => navigate(redirects[language])}
              onKeyDown={e => e.key === 'Enter' && navigate(redirects[language])}
            >
              <div className="postcode-label-row">
                <span className="postcode-label-text">{labels.postcode}</span>
                <svg className="postcode-chevron" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
                  <path d="M12.0005 15.7121L5.9905 9.70211L7.4035 8.28711L12.0005 12.8871L16.5965 8.28711L18.0105 9.70111L12.0005 15.7121Z" fill="#12203A"/>
                </svg>
              </div>
              <div className="postcode-placeholder">Enter postcode</div>
            </div>
          )}
          <button type="submit" className="rental-estimate-btn-hero">
            {labels.buttonLabel}
            <svg className="btn-arrow-hero" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
              <path d="M15.7121 12.0005L9.70211 5.9905L8.28711 7.4035L12.8871 12.0005L8.28711 16.5965L9.70111 18.0105L15.7121 12.0005Z" fill="#12203A"/>
            </svg>
          </button>
        </form>
      </div>
      {showReviewsBanner && (
        <div id="custom-reviews-banner">
          <label>
            Rated <b>4.7</b> / 5 based on <b>2,035 reviews</b>. Showing our favourite reviews.
          </label>
          <br></br>
          <a {...trustpilotLinkProps}>
            <StaticImage
              src={'../../assets/images/tp-logo.png'}
              className="responsive-img"
              alt="CityRelay" />
          </a>
        </div>
      )}
    </>
  ) : (
    <form
      className="flex flex-col sm:flex-row input-postcode"
      onSubmit={e => {
        e.preventDefault();
        navigate(`${redirects[language]}`);
      }}
    >
      <input value={value} onChange={e => setValue(e.target.value)} type="text" placeholder={labels.postcode} className="bg-white px-5 py-4 md:py-6 w-full outline-none text-navy postcode-input" />
      <Button type="button" title={labels.buttonLabel} className="inline-flex items-center whitespace-nowrap get-rental-estimate-btn" />
    </form>
  );

  if (sideBySide) {
    return (
      <div className={`rental-cta-split ${className}`}>
        <div className="rental-cta-split-heading">{headingBlock}</div>
        <div className="rental-cta-split-form">
          {formBlock}
          {showHelpFeatures && (
            <HelpFeatures language={language ?? 'en'} />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`${className}`}>
      {headingBlock}
      {formBlock}

      {showHelpFeatures && (
        <HelpFeatures language={language ?? 'en'} />
      )}

    </div >
  )
}
